/**
 * Mode-aware fill copy — same instinct as Rate My Trade's tone-aware verdict
 * text ("They cooked." / "They got fleeced."), tuned for a trading desk.
 * No exclamation points, ever — matches the house voice.
 */

const OPEN_LINES = {
  long: ['Filled. Conviction, taken.', 'Bought in.', 'That’s a position.'],
  short: ['Betting against the room.', 'Filled. Short and sure.', 'Against the grain.'],
};

const CLOSE_LINES = {
  profit: ['Booked. Chips in the bank.', 'Booked. Called it.'],
  loss: ['Booked. Live to trade again.', 'Booked. On to the next one.'],
  flat: ['Booked. A wash, not a waste.'],
};

let openIdx = 0;
let closeIdx = 0;

export function pickOpenLine(side) {
  const lines = OPEN_LINES[side] || OPEN_LINES.long;
  const line = lines[openIdx % lines.length];
  openIdx += 1;
  return line;
}

export function pickCloseLine(pnl) {
  const bucket = pnl > 0 ? 'profit' : pnl < 0 ? 'loss' : 'flat';
  const lines = CLOSE_LINES[bucket];
  const line = lines[closeIdx % lines.length];
  closeIdx += 1;
  return line;
}
